//updated by Halimuunnisa on 2024-06-17
//Updated to handle new pipeline stages and navigate to documents tab for 'documents' stage. Disabled button for 'new' and 'assigned' stages with tooltip.

import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { TableActionButton } from "@/components/ui";
import { PROJECT_PIPELINE_STAGES } from "@/constants/globalConstants";

export const StageDropdown = ({ lead, currentStatus }) => {
  const navigate = useNavigate();

  const activeStatus = currentStatus || lead?.leadStatus || "new";
  const stageIndex = PROJECT_PIPELINE_STAGES.findIndex(s => s.key === activeStatus);
  const isValidTab = stageIndex >= 0 && activeStatus !== 'new' && activeStatus !== 'assigned';
  const isDisabled = !isValidTab;

  const handleClick = (e) => {
    e.stopPropagation();
    if (!isDisabled) {
      const leadId = lead?._id || lead?.id || "";
      const idParam = leadId ? `&leadId=${leadId}` : "";

      if (activeStatus === 'documents') {
        navigate(`/documents?leadId=${leadId}`);
      } else {
        navigate(`/leads?tab=${activeStatus}${idParam}`);
      }
    }
  };

  return (
    <div className="inline-flex">
      <TableActionButton
        icon={ArrowUpRight}
        variant="primary"
        onClick={handleClick}
        disabled={isDisabled}
        title={isDisabled ? "No workflow tab available yet" : "Go to current stage tab"}
      />
    </div>
  );
};
